import { render } from "./RegisterProvider.vue?vue&type=template&id=75badd00&scoped=true"
import script from "./RegisterProvider.vue?vue&type=script&lang=js"
export * from "./RegisterProvider.vue?vue&type=script&lang=js"

import "@/assets/css/layout_registerProvider.css?vue&type=style&index=0&id=75badd00&scoped=true&lang=css"
import "./RegisterProvider.vue?vue&type=style&index=1&id=75badd00&scoped=true&lang=css"

import exportComponent from "C:\\DEVER\\meta-buysell.vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-75badd00"]])

export default __exports__